import script from "./DefaultFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefaultFooter.vue?vue&type=script&lang=ts&setup=true"

import "./DefaultFooter.vue?vue&type=style&index=0&id=0c42039d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c42039d"]])

export default __exports__